<template>
	<dms-select-grid v-bind="{ labelKey: 'PP_NR', disabled, validationOff, span, noLabelAlign }" @clear="clearClick">
		<dms-input ref="nrInput" :disabled="isDisabled" :value.sync="ppnrCmp" label-key="PP_NR" :span="24" :show-label="false" :wrapp="false"
			class="input-with-select" validation-off :autofocus="autofocus" @input="$emit('input')" />
		<template slot="buttons">
			<dms-button :disabled="isDisabled" :wrapp="false" text="..." @click="openPpServiceNrGrid()" />
			<dms-button :disabled="isDisabled || isPpDruhSelectDisabled" :wrapp="false" text=".." @click="openPpDruhGrid()" />
		</template>
		<template v-if="showPpButton" slot="buttonsEnd">
			<dms-button ref="selectButton" :disabled="isDisabled || isPpButtonDisabled" :wrapp="false" class="btn-sel-height pracovni-pozice-btn" label-key="tcmenupPP"
				@click="openPracovniPoziceGrid()" />
		</template>
	</dms-select-grid>
</template>

<script>
import _ from 'lodash';
import { openSelectList } from '@/main/router/routerPath';
import { PPDRUH, PPNR, PPSERVICENR } from '@/modules/ciselnik/dilenske/constants';
import { NAME as PRACOVNI_POZICE } from '@/modules/ciselnik/dilenske/pracovniPozice/constants';

import { BaseSelect, selectName } from '#components/baseSelect';

export default BaseSelect.extend({
	name: selectName(PPNR),
	props: {
		ppServiceNrFilter: { type: Object, required: true },
		ppDruhFilter: { type: Object, required: true },
		showPpButton: { type: Boolean, default: false },
		pracovniPoziceFilter: { type: Object, default: () => {} },
		pracovniPoziceCheck: { type: Function, default: () => new Promise((resolve) => resolve(true)) },
		ppnr: { type: String },
		isPpButtonDisabled: { type: Boolean, default: false },
	},
	data() {
		return {
			emptyObject: {
				ppNr: null,
				popis: null,
			},
		};
	},
	computed: {
		isPpDruhSelectDisabled() {
			return this.ppnr === null || this.ppnr === undefined || this.ppnr.length < 4;
		},
		ppnrCmp: {
			get() {
				return this.ppnr;
			},
			set(val) {
				this.$emit('update:ppnr', val);
			},
		},
	},
	methods: {
		focusInput() {
			this.$refs.nrInput.focus();
		},
		async openPpServiceNrGrid() {
			await openSelectList(
				PPSERVICENR,
				{
					afterRowSelection: this.selected,
					filter: this.ppServiceNrFilter,
					showFilter: false,
				},
			);
			this.setPageManagerMapper();
		},
		async openPpDruhGrid() {
			await openSelectList(
				PPDRUH,
				{
					afterRowSelection: this.selected,
					filter: this.ppDruhFilter,
					showFilter: false,
				},
			);
			this.setPageManagerMapper();
		},
		async openPracovniPoziceGrid() {
			const result = await this.pracovniPoziceCheck();
			if (result) {
				await openSelectList(
					PRACOVNI_POZICE,
					{
						afterRowSelection: this.selected,
						filter: this.pracovniPoziceFilter,
						showFilter: false,
					},
				);
				this.setPageManagerMapper();
			}
		},
		getPopis(data) {
			if (_.has(data, this.textFieldName)) {
				return data[this.textFieldName];
			}
			if (_.has(data, 'X_POPIS')) {
				return data.X_POPIS;
			}
			return null;
		},
		dbToBaseMapper(data) {
			if (_.has(data, 'PP_NR')) {
				return {
					zaznamId: data.ZAZNAM_ID,
					tablPozice: data.X_TABLPOZICE,
					popis: this.getPopis(data),
					casJdnPoc: data.CAS_JDN_POC,
					lakJdnPoc: data.LAK_JDN_POC,
					zarmobilPznZkt: data.X_ZARMOBIL_PZN_ZKT,
					ppNr: data.PP_NR,
					editPrp: data.EDIT_PRP,
					selectComplete: true,
					pcPevna: data.PC_PEVNA,
					pcSpec: data.PC_SPEC,
				};
			}
			return {
				ppNr: data.PP_SERVIS_NR || (this.ppnr ? `${this.ppnr}${data.PP_DRUH}` : null),
			};
		},
	},
});
</script>

<style scoped>
.pracovni-pozice-btn {
	margin-left: 5px;
}
</style>
